import { useNavigate } from 'react-router-dom';
import { Button } from '@cropler/ui-kit';


import { WorkspaceList } from '../WorkspaceList/index.jsx';
import { ProfileMenu } from '../ProfileMenu/ProfileMenu.jsx';
import { useViewport } from '../../hooks';
import { BreakpointMobile } from '../../constants/ui';
import { Icon as CroplerIcon } from '@cropler/ui-kit';

const Header = ({ t, title, withBackButton = false, backButtonText, onBackButton, isHeaderCompact = false }) => {
  const navigate = useNavigate();
  const { widthViewport } = useViewport();

  const goBack = () => {
    navigate(-1);
  };

  return (
    <header className="header">
      {withBackButton && (
        <Button type="text" icon={<CroplerIcon name="left" />} onClick={onBackButton ? onBackButton : goBack}>
          {backButtonText ? backButtonText : ''}
        </Button>
      )}
      {title && widthViewport > BreakpointMobile && <h2 className="header-title">{title}</h2>}
      {!isHeaderCompact && (
        <div className="header-nav">
          <WorkspaceList t={t} />
          <ProfileMenu t={t} />
        </div>
      )}
    </header>
  );
};

export default Header;
